import {
	pricesListsUpdateApply,
	pricesListsUpdatePaginate,
	pricesListsUpdateRecord
} from 'api/PricesListsMassiveUpdateApi'
import {
	IPricesListsUpdateApplySaga,
	IPricesListsUpdatePaginateSaga,
	IPricesListsUpdateRecordSaga
} from 'models/PricesListsMassiveUpdate'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import {
	pricesListsUpdateApplySuccess,
	pricesListsUpdatePaginateSuccess,
	pricesListsUpdateRecordSuccess
} from '../actions'
import {
	SET_PRICES_LISTS_APPLY,
	SET_PRICES_LISTS_PAGINATE,
	SET_PRICES_LISTS_RECORD
} from '../constants/ActionsTypes'

function* pricesListsUpdateApplyReq({
	payload
}: IPricesListsUpdateApplySaga): any {
	try {
		const values: any = yield call(pricesListsUpdateApply, payload)
		yield put(pricesListsUpdateApplySuccess(values))
	} catch (error) {}
}
function* pricesListsUpdateRecordReq({
	payload
}: IPricesListsUpdateRecordSaga): any {
	try {
		const values: any = yield call(pricesListsUpdateRecord, payload)
		yield put(pricesListsUpdateRecordSuccess(values))
	} catch (error) {}
}
function* pricesListsUpdatePaginateReq({
	payload
}: IPricesListsUpdatePaginateSaga): any {
	try {
		const values: any = yield call(pricesListsUpdatePaginate, payload)
		yield put(pricesListsUpdatePaginateSuccess(values))
	} catch (error) {}
}

export function* pricesListsUpdateApplySaga() {
	yield takeLatest(SET_PRICES_LISTS_APPLY, pricesListsUpdateApplyReq)
}
export function* pricesListsUpdateRecordSaga() {
	yield takeLatest(SET_PRICES_LISTS_RECORD, pricesListsUpdateRecordReq)
}
export function* pricesListsUpdatePaginateSaga() {
	yield takeLatest(SET_PRICES_LISTS_PAGINATE, pricesListsUpdatePaginateReq)
}
export default function* rootSaga() {
	yield all([
		fork(pricesListsUpdateApplySaga),
		fork(pricesListsUpdateRecordSaga),
		fork(pricesListsUpdatePaginateSaga)
	])
}
